import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteApplyList', {
    sectionName: 'Applied To',
    dateDueColumnName: 'Date due',
    typeColumnName: 'Type',
    referenceColumnName: 'Reference',
    originalAmountColumnName: 'Original amount',
    amountDueColumnName: 'Amount due',
    currencyColumnName: 'Currency',
    discountDateColumnName: 'Discount date',
    discountAvailableColumnName: 'Discount available',
    discountAmountColumnName: 'Discount taken',
    paymentAmountColumnName: 'Payment',
    discountAmountFieldPlaceholder: 'Enter value',
    paymentAmountFieldPlaceholder: 'Enter value',
});
